import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';

export const validatePhone = (phone) => {
  try {
    return isValidPhoneNumber(phone, 'US');
  } catch {
    return false;
  }
};

export const formatPhone = (phone) => {
  try {
    const phoneNumber = parsePhoneNumber(phone, 'US');
    return phoneNumber ? phoneNumber.formatNational() : phone;
  } catch {
    return phone;
  }
};

export const normalizePhone = (phone) => {
  return phone.replace(/\D+/g, '');
};

export const toE164 = (phone) => {
  try {
    const phoneNumber = parsePhoneNumber(phone, 'US');
    return phoneNumber ? phoneNumber.number : `+1${normalizePhone(phone)}`;
  } catch {
    return `+1${normalizePhone(phone)}`;
  }
};
